export const valueFromString = function(obj, str) {
  let value;

  try {
    value = str.split('.').reduce((o, i) => o[i], obj)
  } catch (error) {
    value = null;
  }
  
  return value;
}

export const trimObjectValues = function(obj) {
  if(obj == null || obj == undefined || Object.keys(obj).length === 0) return;

  Object.keys(obj).map(field => {
    if(typeof obj[field] === 'string') obj[field] = obj[field].trim();
  });

  return obj;
}

export const removeEmptyProps = function(obj) {
  const newObj = {};

  Object.keys(obj).forEach(key => {
    if (
        ( Array.isArray(obj[key]) && obj[key].length ) ||
        ( !Array.isArray(obj[key]) && obj[key] )
      ) newObj[key] = obj[key];
  });

  return newObj;
}

// Axios turns null into an empty query value. Drop only null, undefined, and ''
// so 0, false, and arrays (including empty arrays) stay and axios can encode them.
export const definedQueryParams = function(data) {
  const params = {};
  if (data === null || data === undefined) {
    return params;
  }
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value === null || value === undefined || value === '') {
      return;
    }
    params[key] = value;
  });
  return params;
}